import React, { useEffect, useState } from 'react';
import { applyActionCode } from 'firebase/auth';
import { auth } from './firebase';

function VerificarEmail() {
  const [mensagem, setMensagem] = useState('Verificando seu e-mail, aguarde...');
  const [erro, setErro] = useState(false);

  useEffect(() => {
    document.title = 'PromoAlert | Verificação de e-mail';

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('oobCode');

    if (code) {
      applyActionCode(auth, code)
        .then(() => {
          setMensagem('E-mail verificado com sucesso. Você já pode fechar esta tela e voltar ao aplicativo.');
        })
        .catch((error) => {
          console.error(error);
          setErro(true);
          setMensagem('O link é inválido ou já expirou. Faça login novamente para solicitar um novo envio.');
        });
    } else {
      setErro(true);
      setMensagem('Nenhum código de verificação foi encontrado neste link.');
    }
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
        background: 'linear-gradient(180deg, #f3f7fb 0%, #ffffff 100%)',
        padding: '24px',
      }}
    >
      <div
        style={{
          backgroundColor: '#ffffff',
          padding: '40px',
          borderRadius: '24px',
          boxShadow: '0 24px 60px rgba(15, 23, 42, 0.08)',
          textAlign: 'center',
          maxWidth: '440px',
          border: '1px solid #dbe5f0',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            borderRadius: '999px',
            backgroundColor: '#eef6ff',
            color: '#0f4c81',
            border: '1px solid #cfe3f8',
            padding: '8px 14px',
            fontSize: '12px',
            fontWeight: '700',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            marginBottom: '18px',
          }}
        >
          PromoAlert | VMS
        </div>
        <h1 style={{ color: erro ? '#b91c1c' : '#0f5ca8', margin: '0 0 16px', fontSize: '32px' }}>
          {erro ? 'Falha na verificação' : 'E-mail confirmado'}
        </h1>
        <p style={{ fontSize: '16px', color: '#4b5563', lineHeight: '1.6', margin: 0 }}>{mensagem}</p>
      </div>
    </div>
  );
}

export default VerificarEmail;
